import { rbac } from "config/rbac";
import { useCheckPerms } from "./useCheckPerms";

export const useHasSalesEnablementReadAccess = () =>
  useCheckPerms(rbac.readSalesEnablement);
